export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  MANAGER: "Manager",
  TEAM_LEADER: "Team Leader",
  WORKER: "Worker",
};